/**
 * The dock's countdown ticker: a presentation-only timer (no store, no socket),
 * shared by the two countdown cards.
 */
import {useEffect, useState} from 'react';

const TICK_MS = 250;

const secondsLeft = (until: number | null): number =>
  until ? Math.max(0, Math.ceil((until - Date.now()) / 1000)) : 0;

export const useCountdown = (until: number | null): number => {
  const [left, setLeft] = useState(() => secondsLeft(until));
  useEffect(() => {
    if (!until) {
      return undefined;
    }
    const tick = () => setLeft(secondsLeft(until));
    tick();
    const interval = setInterval(tick, TICK_MS);
    return () => clearInterval(interval);
  }, [until]);
  return left;
};

export const mmss = (seconds: number): string =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
